<ion-content id="content-wrapper" fullscreen="true">
  <ion-grid class="h-100">
    <ion-row id="login-wrapper" class="h-100 ion-justify-content-center ion-align-items-center">
      <ion-col size-lg="auto" size="12">
        <div id="brand" class="ion-margin">
          <ion-img id="seos-logo" [src]="'assets/images/seos_logo.png'"></ion-img>
          <ion-img id="seos-text" [src]="'assets/images/seos_text.png'"></ion-img>
          <div id="seos-long-text">smart education operating system</div>
        </div>
      </ion-col>
      <ion-col id="divider" size="auto" class="ion-hide-lg-down"></ion-col>
      <ion-col size-md="6" size-xl="4" size="12">
        <div id="form-wrapper">
          <form id="pairDeviceForm" #pairingForm="ngForm" class="w-100" (ngSubmit)="onPair()" method="post" novalidate>
            <div class="title">{{ 'LOGIN.DEVICE_PAIRING' | translate }}</div>
            <ion-item lines="none" class="ion-margin">
              <ion-input id="pairingCode"
                         type="text"
                         name="username"
                         inputmode="numeric"
                         minlength="6"
                         maxlength="6"
                         [label]="'LOGIN.PAIRING_CODE' | translate"
                         labelPlacement="floating"
                         [(ngModel)]="pairingCode"
                         appNumeric
                         required>
              </ion-input>
            </ion-item>
            <ion-button type="submit" class="ion-margin" [disabled]="pairingForm.invalid" expand="block">
              {{ 'LOGIN.PAIR' | translate }}
            </ion-button>
          </form>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
